import { atomWithStorage } from 'jotai/utils';

export type MarketInsightVersionStatus = 'unseen' | 'seen' | 'dismissed' | 'visited';

export const marketInsightVersionStatusAtom = atomWithStorage<MarketInsightVersionStatus>(
  'market-insight-version-status',
  'unseen',
);
